import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { gbp, gbpSigned } from "@/lib/format";
import { Landmark, Wallet, Trash2, ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function BalanceOverview({ data, onReload }) {
  const { total_balance = 0, net = 0, accounts = [] } = data || {};

  const disconnect = async (id, name) => {
    try {
      await api.delete(`/accounts/${id}`);
      toast.success(`Disconnected ${name}`);
      onReload?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="mm-glow-card p-6 h-full" data-testid="balance-overview">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#00C896]">Total balance</p>
          <p data-testid="total-balance" className="font-num text-4xl sm:text-5xl font-extrabold tracking-tight text-white mt-2">
            {gbp(total_balance)}
          </p>
          <div className={`mt-2 inline-flex items-center gap-1 text-sm ${net >= 0 ? "text-[#00C896]" : "text-rose-400"}`}>
            {net >= 0 ? <ArrowUpRight className="h-4 w-4" /> : <ArrowDownRight className="h-4 w-4" />}
            <span className="font-num">{gbpSigned(net)}</span>
            <span className="text-slate-500">net this month</span>
          </div>
        </div>
        <span className="h-11 w-11 rounded-xl bg-[#00C896]/15 flex items-center justify-center text-[#00C896]">
          <Wallet className="h-5 w-5" />
        </span>
      </div>

      <div className="mt-6 space-y-2.5">
        <p className="text-xs text-slate-500 flex items-center gap-1.5"><Landmark className="h-3.5 w-3.5" /> Connected UK accounts</p>
        {accounts.map((a) => (
          <div key={a.id} data-testid={`account-row-${a.id}`} className="group flex items-center justify-between rounded-xl border border-white/8 bg-[#0D0D0D] px-3.5 py-3">
            <div className="flex items-center gap-3 min-w-0">
              <span className="h-9 w-9 rounded-lg flex items-center justify-center font-display font-bold text-sm text-white shrink-0" style={{ background: a.bank_color || "#00C896" }}>
                {a.bank_name?.[0]}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{a.account_name}</p>
                <p className="text-[11px] text-slate-500 font-num">{a.bank_name} · {a.account_number}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-num font-semibold text-sm">{gbp(a.balance)}</span>
              <button
                data-testid={`disconnect-${a.id}`}
                onClick={() => disconnect(a.id, a.account_name)}
                className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-rose-400 transition"
                title="Disconnect"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
